<template lang="pug">

  button( @click="onStaticSiteToggle" ) {{toggle_copy}}

</template>

<script>

import gsap from 'gsap'
import { mapState, mapMutations } from 'vuex' 
import { MODAL_STATES, PATHS } from 'src/config/app'
import CloseSvg from 'src/assets/svgs/close.svg'

export default { 

  props: { 
    theme: String 
  },

  mounted(){ 
    this.$el.classList.toggle('dark', this.theme === 'dark')
  },

  computed: {

    ...mapState('app', [
      'reduced_motion'
    ]),

    toggle_copy(){
      return this.reduced_motion ? 'ANIMATED SITE' : 'STATIC SITE'
    }
  },

  components: {},

  methods: { 
    onStaticSiteToggle(){ 
      let qs = this.reduced_motion ? '' : '?_reduced_motion'
      window.location.href = window.location.origin + window.location.pathname + qs
    }
  }
}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
  


</style>
